export default {
  namespaced: true,
  schedule_alarm: {
    title: "programação de alarme|programação de alarmes",
    name: "nome",
    apply_holliday: "aplicar feriado",
    allow_alarms: "permitir alarmes",
    replicate_all_days: "Replicar para todos os dias",
    select_all_units: "Selecionar todas as instalações",
    clear_all_units: "Remover todas as instalações",
    loading_all_units: "Buscando instalações...",
    day: 'dia',
    month: 'mês',
    months: {
      january: 'janeiro',
      february: 'fevereiro',
      march: 'março',
      april: 'abril',
      may: 'maio',
      june: 'junho',
      july: 'julho',
      august: 'agosto',
      september: 'setembro',
      october: 'outubro',
      november: 'novembro',
      december: 'dezembro',
    },
  },
}












